import React from 'react'

function Result() {
  return (
    <>
    <div className="col-lg-3 offset-lg-3 rounded-4 my_primary">    
    <div className='text-center text-white  px-4'>
      <p className='mt-4 text_light'>Your Result</p>
      <div className="rounded-circle bg_circle mx-2 py-5 px-1">
        <h1 className='mt-1'>76</h1>
        <span className='text-white text-opacity-50 fw-bold '>of 100</span>
      </div>
      <div className='mt-4 mb-5'>
        <h4 className='my-2'>Great</h4>
        <p className='text_light' style={{fontSize:"13sp"}}>You scored is higher than 65% of the people who have taken these tests.</p>
      </div>
    </div>
</div>
    </>
  )
}

export default Result